import { createContext } from 'react';
export const CommonDataContext = createContext({
    providers: [],
    resourceLocations: [],
    featureFlags: {},
});
